import { TradingPanel } from '@trading-ui/core';
import { TradingDatagrid } from '@trading-ui/tables';
import { useTranslation } from 'react-i18next';

import type { Plant } from '@/interfaces';

import * as styles from './CompanyCupsTable.css';

type CompanyCupsTableProps = {
  columns: any[];
  data: Plant[];
  isLoading: boolean;
  isRefetching: boolean;
};

export default function CompanyCupsTable({ columns, data, isLoading, isRefetching }: CompanyCupsTableProps) {
  const { t } = useTranslation();
  return (
    <TradingPanel className={styles.root}>
      <div className={styles.tableContainer}>
        <TradingDatagrid
          tableHeight="calc(50vh - 200px)"
          columnsTable={columns}
          dataTable={data}
          flexLayout
          keepSelectedRowsOnPageChange={false}
          columnOrder={[]}
          stickyColumns={{
            identifier: 'left',
            edit: 'right',
            delete: 'right',
          }}
          isLoadingMore={isRefetching || isLoading}
          noDataMessage={isRefetching || isLoading ? '' : t('settings.companyDetailsTab.companyCups.emptyMessage')}
        />
      </div>
    </TradingPanel>
  );
}
